



























import Vue from 'vue';
import { Relation } from 'expangine-runtime';
import { editRelationDialog } from './EditRelation';


export default Vue.extend({
  data: () => editRelationDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    title(): string {
      return this.name ? 'Edit Relation' : 'Add Relation';
    },
    isSaved(): boolean {
      return !!this.relation && this.registry.defs.getRelation(this.relation.name) === this.relation;
    },
    buttonText(): string {
      return this.isSaved ? this.confirm : this.unconfirm;
    },
  },
  methods: {
    finish() {
      this.done(this.isSaved);
    },
    removed() {
      this.done(false);
    },
    setRelation(relation: Relation) {
      this.relation = relation;
    },
  },
});
